
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import app from "./firebase";


export const messaging =
    typeof window !== "undefined" ? getMessaging(app) : null;

export const requestNotificationPermission = async () => {
    if (!messaging) return;

    const permission = await Notification.requestPermission();

    if (permission === "granted") {
        try {
            const token = await getToken(messaging, {
                vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
            });
            return token;
        } catch (error) {
            console.error("Error getting FCM token:", error);
            throw error;
        }
    } else {
        console.log("Notification permission denied");
    }
};

export const onMessageListener = () =>
    new Promise((resolve) => {
        if (!messaging) return;

        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });
